export default function AboutMe() {
  return (
    <div className="p-5 sm:h-screen flex flex-col justify-center items-center">
      <h1>about me</h1>
      <span className="text-base md:w-2/5">
        <p className="mb-3">
          Hi there. I'm a sophomore at Northeastern University studying Computer
          Science and Philosophy. My home country is Singapore, and so prior to
          university, I spent two years working as a police officer in the
          Singapore Police Force to fulfill my national service requirements.
        </p>
        <p className="mb-3">
          Within Computer Science, my interests have primarily been in web
          development, which I have been teaching myself through YouTube, Stack
          Overflow, and lots of trial and error. Regardless, I enjoy programming
          in general, and I'd love to try out and experience opportunities in
          other areas such as mobile development and music production software!
        </p>
        <p className="">
          Outside of coding, I really enjoy music and playing the piano. In the
          past, I used to produce a lot of music, however, more recently I've
          mainly been focusing on becoming a better jazz pianist and have been
          playing in the Northeastern Jazz Ensemble as well as Northeastern Jazz
          Combo and Choir.
        </p>
      </span>
    </div>
  );
}
